<template>
    <ContentOrLoading :style="!valores_grafica ? 'padding: 50px;' : ''">
        <GChart
            v-if="valores_grafica"
            type="PieChart"
            :data="valores_grafica"
            :options="chartOptions"
        />
    </ContentOrLoading>
</template>

<script>
export default {
    props: ['url', 'params'],
    data() {
        return {
            valores_grafica : null,
            chartOptions: {
                height: 250,
                chartArea: { width:'100%' },
                sliceVisibilityThreshold: 0
            }
        }
    },
    methods: {
        getInformeWhatsapp() {
            const parametros = this.params;

            this.$store.dispatch(this.config.getVuexAlias(this.url), parametros).then(res => {
                this.valores_grafica = res.data;
            });
        }
    },
    created() {
        this.getInformeWhatsapp();
    }
}
</script>